var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenILogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Lager_1",
    width: 232.012,
    height: 69.641,
    "data-name": "Lager 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-18.4 -18.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1",
    d: "M18.4 18.22h216.63V48.7H18.4z",
    style: {
      fill: "none"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".cls-2{fill:#439539}"))), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M232.012 30.114a13.034 13.034 0 1 1-26.067 0c0-11.229 13.033-12.468 13.033-30.114 0 17.646 13.034 18.885 13.034 30.114z",
    className: "cls-2",
    style: {
      strokeWidth: 1.82289
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M228.384 30.52a.966.966 0 0 0-.911.802 6.909 6.909 0 0 1-5.96 5.469.839.839 0 0 0-.767.82.766.766 0 0 0 .82.766 8.458 8.458 0 0 0 7.53-7.018.674.674 0 0 0-.712-.839z",
    style: {
      strokeWidth: 1.82289,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M19.736 69.64c-6.38 0-11.904-2.662-16.844-9.115l6.599-5.159c3.263 4.175 6.526 5.688 10.555 5.688a10.08 10.08 0 0 0 10.682-10.081 16.88 16.88 0 0 1-10.682 3.646 20.052 20.052 0 0 1 0-40.104 17.08 17.08 0 0 1 10.682 3.646v-2.953h9.114V49.35a19.851 19.851 0 0 1-20.106 20.288zm.455-46.649c-5.997 0-10.536 5.16-10.536 11.612 0 6.453 4.539 11.594 10.536 11.594 5.998 0 10.537-5.159 10.537-11.594s-4.54-11.575-10.537-11.575z",
    className: "cls-2",
    style: {
      strokeWidth: 1.82289
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M57.05 35.551v18.503h-9.114V15.208h9.114v3.882c3.263-3.044 6.38-4.174 11.995-4.63v8.495c-9.26 1.112-11.995 6.909-11.995 12.596z",
    className: "cls-2",
    style: {
      strokeWidth: 1.82289
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M108.565 38.194H79.508c.602 4.485 5.47 8.04 10.1 8.04a14.583 14.583 0 0 0 10.663-5.305l6.143 5.614a21.875 21.875 0 0 1-16.825 8.112 20.052 20.052 0 1 1 0-40.104 19.177 19.177 0 0 1 19.341 19.797c-.073 1.495-.365 3.846-.365 3.846zM89.516 23.028a10.445 10.445 0 0 0-9.935 7.127h19.195a9.443 9.443 0 0 0-9.26-7.127z",
    className: "cls-2",
    style: {
      strokeWidth: 1.82289
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M150.273 38.194h-29.038c.601 4.485 5.377 8.04 10.08 8.04a14.583 14.583 0 0 0 10.7-5.305l6.144 5.614a21.875 21.875 0 0 1-16.899 8.112 20.052 20.052 0 1 1 0-40.104 19.195 19.195 0 0 1 19.323 19.852 37.862 37.862 0 0 1-.31 3.791zM131.26 23.028a10.427 10.427 0 0 0-9.934 7.127h19.195a9.46 9.46 0 0 0-9.26-7.127z",
    className: "cls-2",
    style: {
      strokeWidth: 1.82289
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M180.697 54.054V31.45c0-5.469-3.336-8.422-7.802-8.422-4.466 0-8.057 3.19-8.057 8.64v22.386h-9.114V15.208h9.114v2.515a16.15 16.15 0 0 1 10.026-3.117c8.878 0 15.02 6.216 15.02 16.151v23.297z",
    className: "cls-2",
    style: {
      strokeWidth: 1.82289
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenILogo);
export default __webpack_public_path__ + "static/media/Green_I_Logo.78d80eac951eb1fc6c503b9fadd21ed2.svg";
export { ForwardRef as ReactComponent };